import { Advantages } from './Advantages/Advantages'
import { Interconnect } from '../../home/sections/Interconnect/Interconnect'
import { Plans } from './Plans/Plans'
import { Representative } from './Representative/Representative'
import { Results } from './Results/Results'

export { Advantages, Interconnect, Plans, Representative, Results }
